import React from 'react';
import PropTypes from 'prop-types';

const TextInput = ({
    value,
    onChange,
    onKeyDown,
    placeholder,
    label,
    id,
    className,
}) => (
    <div className={'al-text-input ' + (className || '')}>
        {label && (
            <label className="al-text-input-label" htmlFor={id}>
                {label}
            </label>
        )}
        <input
            className="al-text-input-field"
            type="text"
            value={value}
            onChange={onChange}
            onKeyDown={onKeyDown}
            id={id}
            placeholder={placeholder || label}
        />
    </div>
);

TextInput.propTypes = {
    value: PropTypes.string,
    onChange: PropTypes.func,
    onKeyDown: PropTypes.func,
    placeholder: PropTypes.string,
    label: PropTypes.string,
    id: PropTypes.string,
    className: PropTypes.string,
};

export default TextInput;
